import { gql } from '@apollo/client'

export const SHARESETTING_FIELDS = [
  'digital_asset_associables',
  'share_setting_copy_options',
  'campaign',
  'campaign.brand',
]

export const SHARE_FIELDS = [
  'lead_imports',
  'campaign',
  'internal_stats',
  'facebook_page',
  'twitter_account',
  'share_setting',
  'created_by',

  ...SHARESETTING_FIELDS.map((x) => `share_setting.${x}`),
]

export const SHARESETTING_FIELDS_FRAGMENT = gql`
  fragment ShareSettingFieldsFragment on ShareSetting {
    name
    post_format
    responsive_share_image_url
    retailer_description
    retailer_link
    retailer_share_url_type
    retailer_title
    retailer_post_format
    share_type
    link
    allow_retailer_url_override
    description
    share_url_type
    retailer_body
    retailer_subject
    title
    digital_assets {
      id
      download_url
      external_video_url
      responsive_share_image_url
      file {
        id
        public_id
      }
    }
    child_attachments {
      id
      allow_retailer_url_override
      call_to_action
      description
      link
      media {
        media_type
        source_type
        source_id
      }
      name
      share_url_type
      title
      url

      custom_share_url_id
    }
    share_data {
      share_data {
        post_format
        subject
        body
        title
        description
        link
        share_url_type
        button_text
        embed_code

        rendered_child_attachments {
          id
          allow_retailer_url_override
          call_to_action
          description
          link
          media {
            media_type
            source_type
            source_id
          }
          name
          share_url_type
          title
          url

          custom_share_url_id
        }
      }
    }
    digital_asset_associables {
      id
      download_url
      external_video_url
      responsive_share_image_url
      crop_height
      crop_width
      crop_origin_x
      crop_origin_y
      file {
        id
        public_id
        resource_type
      }
    }
    share_setting_copy_options {
      id
      message
    }
    campaign {
      id
      creative_path
      end_date
      brand {
        id
      }
    }
  }
`
export const SHARE_FIELDS_FRAGMENT = gql`
  fragment ShareFieldsFragment on Share {
    channel
    message
    subject
    link
    text_body
    html_body
    text
    post_url
    created_at
    share_setting_id
    facebook_page_id
    twitter_account_id
    retailer_id
    status
    status_message
    updated_at
    updated_by_id
    link_clicks
    retailer_url_override
    scheduled_for
    share_mode
    executed_at
    description
    tweet_url
    tweet_text
    lead_imports {
      id
    }
    campaign {
      id
      creative_path
      link_id
      brand {
        id
        slug
      }
    }
    facebook_page {
      id
      name
      picture_url
    }
    twitter_account {
      id
      name
      nickname
      profile_image_url
    }
    created_by {
      id
      first_name
      last_name
    }
    internal_stats {
      pbxx_actions
      pbxx_views
      pbxx_consumer_clicks
    }
  }
`

export const GET_SHARE_SETTING_QUERY = gql`
  ${SHARESETTING_FIELDS_FRAGMENT}
  query getShareSettingShareDialog(
    $id: ID!
    $retailer_id: ID!
    $fields: [String!]!
  ) {
    getShareSettingRetailer(
      id: $id
      retailer_id: $retailer_id
      fields: $fields
    ) # fix gql collisions by omitting the id
    # eslint-disable-next-line @graphql-eslint/require-id-when-available
    {
      ...ShareSettingFieldsFragment
    }
  }
`
export const UPDATE_SHARE_MUTATION = gql`
  ${SHARE_FIELDS_FRAGMENT}
  mutation UpdateShare(
    $id: ID!
    $shareType: String!
    $facebook_share: CreateShareFacebookShare
    $instagram_share: CreateShareInstagramShare
    $twitter_share: CreateShareTwitterShare
    $asset_share: CreateShareAssetShare
    $embed_share: CreateShareEmbedShare
    $email_share: CreateShareEmailShare
    $fields: [String!]
  ) {
    updateShare(
      id: $id
      shareType: $shareType
      facebook_share: $facebook_share
      instagram_share: $instagram_share
      twitter_share: $twitter_share
      asset_share: $asset_share
      embed_share: $embed_share
      email_share: $email_share
      fields: $fields
    ) {
      id
      ...ShareFieldsFragment
    }
  }
`
export const DELETE_SHARE_MUTATION = gql`
  mutation DeleteShare($id: ID!, $shareType: ShareTypeParam!) {
    deleteShare(shareId: $id, shareType: $shareType) {
      shareId
    }
  }
`
export const GET_SHARE_QUERY = gql`
  ${SHARE_FIELDS_FRAGMENT}
  ${SHARESETTING_FIELDS_FRAGMENT}
  query getShareDialogConfig(
    $params: ShareParams
    $shareType: ShareTypeParam!
    $shareId: ID!
  ) {
    getShare(params: $params, shareType: $shareType, shareId: $shareId) {
      id
      ...ShareFieldsFragment
      # fix gql collisions by omitting the id
      # eslint-disable-next-line @graphql-eslint/require-id-when-available
      share_setting {
        ...ShareSettingFieldsFragment
      }
    }
  }
`

